import { AuthSource } from '@framework/auth/AuthSource.ts';
import { useClientConfig } from '@framework/auth/client-config/ClientConfigSlice.tsx';
import { getAuthGlobalOptions } from '@framework/auth/options.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Space } from 'antd';
import clx from 'classnames';
import { down } from 'styled-breakpoints';
import styled, { useTheme } from 'styled-components';

// biome-ignore lint/style/noCommonJs: <tbd> no-require-imports
export const frontLogo = { url: require('../../images/logo-rer-white.svg') };

const StyledLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  border: none;
  margin: 0;
  padding: 0;
`;

const LogoWrapper = styled.div`
  width: 82px;
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: start;

  ${down('sm')} {
    width: 54px;
    height: 54px;
  }
  &.is-mobile-affixed {
    width: 36px;
    height: 36px;
    ${down('sm')} {
      width: 36px;
      height: 36px;
    }
  }
`;
const TextWrapper = styled.div`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;

  &.portal-name {
    font-size: 1.6rem;
  }

  ${down('sm')} {
    font-size: 1.4rem;
    &.portal-name {
      font-size: 1.2rem;
    }
  }

  &.is-mobile-affixed {
    font-size: 1rem;
    &.portal-name {
      font-size: 0.8rem;
    }

    ${down('sm')} {
      font-size: 1rem;
      &.portal-name {
        font-size: 0.8rem;
      }
    }
  }
`;
const StyledWrapperSpace = styled(Space)`
  display: flex;
  align-items: center;
  line-height: 1;
  &.clickable {
    cursor: pointer;
  }
  gap: 30px;
  ${down('sm')} {
    gap: 20px;
  }
  &.is-mobile-affixed {
    gap: 10px;
    ${down('sm')} {
      gap: 10px;
    }
  }
`;
export interface IFrontHeaderLogoProps {
  onClick?: () => void;
  mobileAffixed?: boolean | null;
}

function getPortaleName() {
  switch (getAuthGlobalOptions().source) {
    case AuthSource.BackOffice:
      return t('front-header.logo.backoffice', 'Back Office');
    case AuthSource.Admin:
      return t('front-header.logo.admin', 'Admin');
    case AuthSource.FrontOffice:
    default:
      return t('front-header.logo.domande', 'Domande');
  }
}

/**
 * Logo principale dell'applicativo.
 */
export function FrontHeaderLogo(props: IFrontHeaderLogoProps) {
  const theme = useTheme();
  const hasClick = !!props.onClick;

  const { displayName } = useClientConfig();

  const headerAppShortName = displayName ?? 'Portale';
  const headerPortalName = getPortaleName();

  return (
    <StyledWrapperSpace
      onClick={props.onClick}
      className={clx({
        clickable: hasClick,
        'is-mobile-affixed': props.mobileAffixed,
      })}
    >
      <LogoWrapper
        className={clx({ 'is-mobile-affixed': props.mobileAffixed })}
      >
        <StyledLogoImg src={frontLogo.url} alt={theme.logoAltText} />
      </LogoWrapper>
      <Space direction="vertical" size={0}>
        <TextWrapper
          className={clx({ 'is-mobile-affixed': props.mobileAffixed })}
        >
          {headerAppShortName}
        </TextWrapper>
        <TextWrapper
          className={clx('portal-name', {
            'is-mobile-affixed': props.mobileAffixed,
          })}
        >
          {headerPortalName}
        </TextWrapper>
      </Space>
    </StyledWrapperSpace>
  );
}
